<template>
  <v-container fluid class="player-status" style="width: 100%">
    <v-layout column justify-center style="width: 100%">
      <v-layout justify-center class="button">
        <button
          :class="getActiveButtonTime(constants.viewTime.week)"
          @click="changeViewTime(constants.viewTime.week)">
          Week
        </button>
        <button
          :class="getActiveButtonTime(constants.viewTime.month)"
          @click="changeViewTime(constants.viewTime.month)">
          Month
        </button>
        <button
          :class="getActiveButtonTime(constants.viewTime.moreMonths)"
          @click="changeViewTime(constants.viewTime.moreMonths)">
          3 Month
        </button>
        <button
          :class="getActiveButtonTime(constants.viewTime.all)"
          @click="changeViewTime(constants.viewTime.all)">
          All
        </button>
      </v-layout>
      <v-flex>
        <div class="graph">
          <LineChart
            :data="graphData"
            :options="graphOptions"
            v-if="viewStat === constants.stats.overall"
            :height="100"
            :key="updateChart"></LineChart>
          <LineChart
            :data="graphData"
            :options="graphOptions"
            v-if="viewStat === constants.stats.soreness"
            :height="100"
            :key="updateChart"></LineChart>
          <LineChart
            :data="graphData"
            :options="graphOptions"
            v-if="viewStat === constants.stats.fatigue"
            :height="100"
            :key="updateChart"></LineChart>
          <LineChart
            :data="graphData"
            :options="graphOptions"
            v-if="viewStat === constants.stats.stress"
            :height="100"
            :key="updateChart"></LineChart>
          <LineChart
            :data="graphData"
            :options="graphOptions"
            v-if="viewStat === constants.stats.sleep"
            :height="100"
            :key="updateChart"></LineChart>
        </div>
      </v-flex>
      <v-layout justify-center class="button graph-button-bar">
        <button
          @click="changeViewStat(constants.stats.overall)"
          class="graph-button"
          :class="getActiveButtonStat(constants.stats.overall)">
          Overall
        </button>
        <button
          @click="changeViewStat(constants.stats.soreness)"
          class="graph-button"
          :class="getActiveButtonStat(constants.stats.soreness)">
          Soreness
        </button>
        <button
          @click="changeViewStat(constants.stats.fatigue)"
          class="graph-button"
          :class="getActiveButtonStat(constants.stats.fatigue)">
          Fatigue
        </button>
        <button
          @click="changeViewStat(constants.stats.stress)"
          class="graph-button"
          :class="getActiveButtonStat(constants.stats.stress)">
          Stress
        </button>
        <button
          @click="changeViewStat(constants.stats.sleep)"
          class="graph-button"
          :class="getActiveButtonStat(constants.stats.sleep)">
          Sleep
        </button>
      </v-layout>

      <v-layout column flex class="player-status-stats">
        <span class="center-text change-title" v-if="reports.length >= 2">
          {{ changeText }}
        </span>
        <span class="center-text change-title" v-else>Not enough data</span>
        <!-- <span class="white-line"></span> -->
        <v-tooltip right :color="this.colors.green">
          <template v-slot:activator="{ on, attrs }">
            <v-layout v-on="on" v-bind="attrs" justify-center>
              <v-spacer></v-spacer>
              <v-layout column>
                <span class="center-text">Soreness</span>
                <v-layout
                  row
                  align-center
                  justify-center
                  class="round-div"
                  :style="getBorderColor(totalSoreness)">
                  <div :style="getColor(totalSoreness)">
                    {{ totalSoreness }}
                  </div>
                  <v-layout column style="flex: 0 1 auto; margin-left: 5px">
                    <div
                      style="vertical-align: super; font-size: 12px"
                      :style="getColorDifference(sorenessFromLast)">
                      {{ sorenessFromLast }}
                    </div>
                    <div style="vertical-align: sub; font-size: 12px">
                      {{ sorenessStdv }}
                    </div>
                  </v-layout>
                </v-layout>
              </v-layout>
              <v-layout column>
                <span class="center-text">Fatigue</span>
                <v-layout
                  row
                  align-center
                  justify-center
                  class="round-div"
                  :style="getBorderColor(totalFatigue)">
                  <div :style="getColor(totalFatigue)">
                    {{ totalFatigue }}
                  </div>
                  <v-layout column style="flex: 0 1 auto; margin-left: 5px">
                    <div
                      style="vertical-align: super; font-size: 12px"
                      :style="getColorDifference(fatigueFromLast)">
                      {{ fatigueFromLast }}
                    </div>
                    <div style="vertical-align: sub; font-size: 12px">
                      {{ fatigueStdv }}
                    </div>
                  </v-layout>
                </v-layout>
              </v-layout>
              <v-layout column>
                <span class="center-text">Stress</span>
                <v-layout
                  row
                  align-center
                  justify-center
                  class="round-div"
                  :style="getBorderColor(totalStress)">
                  <div :style="getColor(totalStress)">
                    {{ totalStress }}
                  </div>
                  <v-layout column style="flex: 0 1 auto; margin-left: 5px">
                    <div
                      style="vertical-align: super; font-size: 12px"
                      :style="getColorDifference(stressFromLast)">
                      {{ stressFromLast }}
                    </div>
                    <div style="vertical-align: sub; font-size: 12px">
                      {{ stressStdv }}
                    </div>
                  </v-layout>
                </v-layout>
              </v-layout>
              <v-layout column>
                <span class="center-text">Sleep</span>
                <v-layout
                  row
                  align-center
                  justify-center
                  class="round-div"
                  :style="getBorderColor(totalSleep)">
                  <div :style="getColor(totalSleep)">
                    {{ totalSleep }}
                  </div>
                  <v-layout column style="flex: 0 1 auto; margin-left: 5px">
                    <div
                      style="vertical-align: super; font-size: 12px"
                      :style="getColorDifference(sleepFromLast)">
                      {{ sleepFromLast }}
                    </div>
                    <div style="vertical-align: sub; font-size: 12px">
                      {{ sleepStdv }}
                    </div>
                  </v-layout>
                </v-layout>
              </v-layout>
              <v-spacer></v-spacer>
            </v-layout>
          </template>
          <div>• Change from first to last</div>
          <div>• Standard deviation</div>
        </v-tooltip>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { orderBy, isString } from "lodash-es"
import LineChart from "@/components/routes/shared/framework/strips/LineChart.js"
import constants from "@/constants.js"
import moment from "moment"
import { getPagedUserReports } from "@/api/firebase.api.js"
import colors from "@/assets/sass/_variables.sass"

export default {
  name: "GraphContent",
  components: { LineChart },
  props: ["userId"],
  data() {
    return {
      colors,
      initialDateBoundary: this.$moment(new Date()),
      months: constants.months,
      icons: constants.icons,
      constants: constants.playerStatus,
      graphOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                padding: 25,
                // min: 1,
              },
              gridLines: {
                display: true,
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: true,
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
          ],
        },
      },
      viewStat: constants.playerStatus.stats.overall,
      viewTime: constants.playerStatus.viewTime.week,
      updateChart: false,
      graphData: {},
    }
  },
  methods: {
    async loadReportsWithLimit(limit) {
      if (this.isLast) {
        return false
      }
      if (limit === -1) {
        while (!this.isLast) {
          await this.getReports()
        }
      } else {
        await this.getReports()
        const lastReport = this.reports[this.reports.length - 1]
        if (lastReport.date.isAfter(limit)) {
          await this.getReports()
          this.loadReportsWithLimit(limit)
        }
      }
    },

    async getReports() {
      if (!this.isLast) {
        const data = await getPagedUserReports({
          userId: this.userId,
          limit: null,
          referenceToOldestKey: this.lastKey,
        })
        if (data.reports.length === 0) {
          this.$toast.info("No reports available")
        } else {
          const additionalReports = data.reports.filter((report) => {
            if (!this.reports.find((r) => r.id === report.id)) {
              return report
            } else {
              return false
            }
          })
          const newReports = this.reports.concat(additionalReports)
          const sorted = newReports.sort((a, b) => a.timeStamp - b.timeStamp)
          this.reports = sorted
        }
        this.lastKey = data.lastKey
        this.isLast = data.isLast
      }
    },

    calcStdv(reports, param) {
      if (reports?.length < 2) return 0
      // Step 1: Calculate the average soreness score
      const sum = reports.reduce((acc, report) => acc + report[param], 0)
      const average = sum / reports.length
      // Step 2: Calculate the deviations
      const deviations = reports.map((report) => report[param] - average)
      // Step 3: Square each deviation
      const squaredDeviations = deviations.map((deviation) => deviation ** 2)
      // Step 4: Calculate the average of squared deviations
      const averageSquaredDeviation =
        squaredDeviations.reduce((acc, deviation) => acc + deviation, 0) /
        reports.length
      // Step 5: Take the square root to get the standard deviation
      const standardDeviation = Math.sqrt(averageSquaredDeviation)
      return standardDeviation.toFixed(2)
    },

    calcTrend(reports, param) {
      if (reports.length < 2) return { data: 0, slope: 0 }
      const sumOfDates = reports.reduce((acc, report) => {
        return acc + parseInt(report.timeStamp)
      }, 0)
      const sumOfParam = reports.reduce((acc, report) => {
        return acc + parseInt(report[param])
      }, 0)
      const averageDate = sumOfDates / reports.length
      const averageParamValue = sumOfParam / reports.length
      const numerator = reports.reduce(
        (acc, report) =>
          acc +
          (parseInt(report.timeStamp) - averageDate) *
            (parseInt(report[param]) - averageParamValue),
        0
      )
      const denominator = reports.reduce(
        (acc, report) => acc + (parseInt(report.timeStamp) - averageDate) ** 2,
        0
      )
      const slope = numerator / denominator
      const intercept = averageParamValue - slope * averageDate
      const trendLineData = reports.map((report) => {
        const x = parseInt(report.timeStamp)
        const y = slope * x + intercept
        return { x, y }
      })
      trendLineData.sort((a, b) => a.x - b.x)
      // return trendLineData.map((data) => data.y)
      return { data: trendLineData.map((data) => data.y), slope }
      // const formattedSlope = parseFloat(slope.toExponential(2)).toFixed(2)
      // return `${formattedSlope}`
    },

    calcOverallTrend(reports) {
      if (reports.length < 2) return { data: 0, slope: 0 }
      const sumOfDates = reports.reduce((acc, report) => {
        return acc + parseInt(report.timeStamp)
      }, 0)
      const overallSum = reports.reduce((acc, report) => {
        const value =
          ((11 -
            parseInt(report.soreness) +
            (11 - parseInt(report.fatigue)) +
            (11 - parseInt(report.stress)) +
            (11 - parseInt(report.sleep))) *
            10) /
          4
        return acc + value
      }, 0)
      const averageDate = sumOfDates / reports.length
      const averageOverallValue = overallSum / reports.length
      const numerator = reports.reduce((acc, report, index) => {
        const value =
          ((11 -
            parseInt(report.soreness) +
            (11 - parseInt(report.fatigue)) +
            (11 - parseInt(report.stress)) +
            (11 - parseInt(report.sleep))) *
            10) /
          4
        return (
          acc +
          (parseInt(report.timeStamp) - averageDate) *
            (value - averageOverallValue)
        )
      }, 0)
      const denominator = reports.reduce((acc, report) => {
        return acc + (parseInt(report.timeStamp) - averageDate) ** 2
      }, 0)
      const slope = numerator / denominator
      // const formattedSlope = parseFloat(slope.toExponential(2)).toFixed(2)
      const intercept = averageOverallValue - slope * averageDate
      const trendLineData = reports.map((report) => {
        const x = parseInt(report.timeStamp)
        const y = slope * x + intercept
        return { x, y }
      })
      trendLineData.sort((a, b) => a.x - b.x)
      // return trendLineData.map((data) => data.y)
      return { data: trendLineData.map((data) => data.y), slope }
    },

    compareReportWithPrevious(reports, param) {
      let value = 0
      const reportsLength = reports?.length ?? 0
      if (reportsLength - 2 > 0) {
        value =
          parseInt(reports[reportsLength - 1][param]) -
          parseInt(reports[reportsLength - 2][param])
      }
      return value > 0 ? "+" + value : value
    },
    changeViewStat(n) {
      this.viewStat = n
      this.graphData = this.getGraphDataset()
    },
    changeViewTime(n) {
      this.viewTime = n
      this.graphData = this.getGraphDataset()
      const now = new Date()
      const weekFromNow = moment(now).subtract(1, "weeks")
      const monthFromNow = moment(now).subtract(1, "months")
      const threeMonthsFromNow = moment(now).subtract(3, "months")

      let reportsLimit = -1
      switch (n) {
        case 0:
          reportsLimit = weekFromNow
          break
        case 1:
          reportsLimit = monthFromNow
          break
        case 2:
          reportsLimit = threeMonthsFromNow
          break
      }
      this.initialDateBoundary =
        reportsLimit === -1 ? this.$moment(now) : reportsLimit
      this.loadReportsWithLimit(reportsLimit)
    },

    getGraphDataset() {
      // return dataset for linear graph
      const dataSet = {
        labels: [],
        // Object.keys(this.months).map((month) => {
        //  return this.months[month]
        // }), // array of x axis labels
        datasets: [
          {
            label: this.constants.statsNumber[this.viewStat],
            borderColor: "white",
            borderWidth: 1,
            pointBackgroundColor: "white",
            pointBorderColor: [],
            pointBorderWidth: 3,
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            pointRadius: 5,
            lineTension: 0,
          },
          {
            label: "Trend",
            // borderColor: colors.yellow,
            borderWidth: 1,
            fill: false,
            type: "line",
            // data: this.constants.statsNumber[this.viewStat],
          },
        ],
      }
      // going to filter reports for date
      let validDate = this.$moment(new Date())
      switch (this.viewTime) {
        case this.constants.viewTime.week:
          validDate = validDate.subtract(7, "days")
          break
        case this.constants.viewTime.month:
          validDate = validDate.subtract(1, "months")
          break
        case this.constants.viewTime.moreMonths:
          validDate = validDate.subtract(3, "months")
          break
        case this.constants.viewTime.all:
          validDate = null
          break
      }
      const getReportFromDate = (validDate) => {
        return this.reports.filter((report) => {
          const reportDate = this.$moment(report.date)
          return reportDate.isAfter(validDate)
        })
      }
      const tmpReports = validDate ? getReportFromDate(validDate) : this.reports
      const getData = (n) => {
        const thisStatConstants = this.constants.stats
        const arrayValues = []
        const tmpReportsLength = tmpReports.length
        const { data, slope } =
          n === 0 && tmpReportsLength > 1
            ? this.calcOverallTrend(tmpReports)
            : this.calcTrend(
                tmpReports,
                String(this.constants.statsNumber[n].toLowerCase())
              )
        const trendLineData = data
        for (let i = 0; i < tmpReportsLength; i++) {
          let value = null
          let color = null
          const currentData = tmpReports[i]
          currentData.date = isString(currentData.date)
            ? this.$moment(currentData.date)
            : currentData.date
          switch (n) {
            case thisStatConstants.overall:
              value =
                ((11 -
                  currentData.soreness +
                  (11 - currentData.fatigue) +
                  (11 - currentData.stress) +
                  (11 - currentData.sleep)) *
                  10) /
                4
              color =
                value < 60
                  ? "red"
                  : value <= 75
                  ? "orange"
                  : value <= 85
                  ? "yellow"
                  : "rgb(40, 247, 71)"
              break
            case thisStatConstants.soreness:
              value = currentData.soreness
              break
            case thisStatConstants.fatigue:
              value = currentData.fatigue
              break
            case thisStatConstants.stress:
              value = currentData.stress
              break
            case thisStatConstants.sleep:
              value = currentData.sleep
              break
          }
          if (!color) {
            color =
              value > 7
                ? "red"
                : value > 5
                ? "orange"
                : value > 3
                ? "yellow"
                : "rgb(40, 247, 71)"
          }
          arrayValues.push({
            label: currentData.date.format("D MMM YYYY"),
            color,
            value,
          })
        }
        return [arrayValues, trendLineData, slope]
      }
      const [data, trend, slope] = getData.call(this, this.viewStat)
      dataSet.labels = data.map((element) => {
        return element.label
      })
      dataSet.datasets[0].data = data.map((x) => {
        return x.value
      })
      dataSet.datasets[0].pointBorderColor = data.map((x) => {
        return x.color
      })

      this.updateChart = !this.updateChart
      dataSet.datasets[0].data.reverse()
      dataSet.datasets[0].pointBorderColor.reverse()
      dataSet.labels.reverse()
      dataSet.datasets[1].data = trend
      dataSet.datasets[1].borderColor =
        Math.sign(slope) === 1 ? colors.green : colors.orange
      return dataSet
    },
    getBorderColor(value) {
      return {
        "border-color":
          value >= 8 ? "red" : value >= 5 ? "orange" : "rgb(40, 247, 71)",
      }
    },
    getColor(value) {
      return {
        color: value >= 8 ? "red" : value >= 5 ? "orange" : "rgb(40, 247, 71)",
      }
    },
    getColorDifference(value) {
      const newValue = +parseInt(value).toFixed(2)
      return {
        color:
          newValue > 0
            ? "red!important"
            : newValue === 0 // eslint-disable-next-line
            ? "rgba(255, 255, 255, 0.3)!important" // eslint-disable-next-line
            : "rgb(40, 247, 71)!important",
      }
    },
    getActiveButtonStat(buttonNumber) {
      return this.viewStat === buttonNumber
        ? { "active-button": true }
        : { "active-button": false }
    },
    getActiveButtonTime(buttonNumber) {
      return this.viewTime === buttonNumber
        ? { "active-button": true }
        : { "active-button": false }
    },
  },
  computed: {
    reports: {
      get: function () {
        if (
          this.$store.state.reports.playerReports[this.$props.userId] ===
          undefined
        ) {
          return []
        }
        return this.$store.state.reports.playerReports[this.$props.userId]
      },
      set: function (value) {
        this.$store.commit("reports/addPlayerReports", {
          userId: this.$props.userId,
          playerReports: value,
        })
      },
    },
    searchWindow() {
      let searchWindow = "overall"
      switch (this.viewTime) {
        case 0:
          searchWindow = "past 7 days"
          break
        case 1:
          searchWindow = "past 31 days"
          break
        case 2:
          searchWindow = "past 92 days"
          break
        case 3:
          searchWindow = "overall"
          break
      }
      return searchWindow
    },
    reportsWithinBounds() {
      const withinBounds = this.reports.filter((report) => {
        const now = this.$moment(new Date())
        const diffInDays = now.diff(report.date, "days")
        switch (this.viewTime) {
          case 0:
            // within last 7 days
            if (diffInDays <= 7) {
              return report
            }
            break
          case 1:
            // within last 30 days
            if (diffInDays <= 31) {
              return report
            }
            break
          case 2:
            // within last 90 days
            if (diffInDays <= 92) {
              return report
            }
            break
          case 3:
            // all
            return report
        }
        return false
      })
      return orderBy(withinBounds, "timeStamp", "asc")
    },
    initialMonth() {
      const firstReportDate = this.reportsWithinBounds?.[0]?.date
      if (!firstReportDate)
        return `No reports found within ${this.searchWindow}`
      const date = isString(firstReportDate)
        ? this.$moment(firstReportDate)
        : firstReportDate
      return date
    },
    lastMonth() {
      const lastDate = orderBy(this.reports, "timeStamp", "desc")[0].date
      const date = isString(lastDate) ? this.$moment(lastDate) : lastDate
      return date
    },
    mostRecentReport() {
      return orderBy(this.reports, "timeStamp", "desc")[0]
    },
    changeText() {
      const start = this.initialMonth
      const end = this.lastMonth
      if (isString(start)) return `${start}; showing last available report`
      return `Change from ${start.format("DD MMM YYYY")} to ${end.format(
        "DD MMM YYYY"
      )} (last submitted report)`
    },
    totalSoreness() {
      return this.mostRecentReport.soreness
    },
    sorenessFromLast() {
      return this.compareReportWithPrevious(
        this.reportsWithinBounds,
        "soreness"
      )
    },
    sorenessTrend() {
      return this.calcTrend(this.reportsWithinBounds, "soreness")
    },
    sorenessStdv() {
      return this.calcStdv(this.reportsWithinBounds, "soreness")
    },
    totalFatigue() {
      return this.mostRecentReport.fatigue
    },
    fatigueFromLast() {
      return this.compareReportWithPrevious(this.reportsWithinBounds, "fatigue")
    },
    fatigueTrend() {
      return this.calcTrend(this.reportsWithinBounds, "fatigue")
    },
    fatigueStdv() {
      return this.calcStdv(this.reportsWithinBounds, "fatigue")
    },
    totalStress() {
      return this.mostRecentReport.stress
    },
    stressFromLast() {
      return this.compareReportWithPrevious(this.reportsWithinBounds, "stress")
    },
    stressTrend() {
      return this.calcTrend(this.reportsWithinBounds, "stress")
    },
    stressStdv() {
      return this.calcStdv(this.reportsWithinBounds, "stress")
    },
    totalSleep() {
      return this.mostRecentReport.sleep
    },
    sleepFromLast() {
      return this.compareReportWithPrevious(this.reportsWithinBounds, "sleep")
    },
    sleepTrend() {
      return this.calcTrend(this.reportsWithinBounds, "sleep")
    },
    sleepStdv() {
      return this.calcStdv(this.reportsWithinBounds, "sleep")
    },
  },

  mounted() {
    this.graphData = this.getGraphDataset()
    this.changeViewTime(constants.playerStatus.viewTime.week)
  },

  watch: {
    reports(reports) {
      if (reports.length > 0) {
        this.graphData = this.getGraphDataset()
      }
    },
  },
}
</script>

<style lang="sass">
@import '@/assets/sass/_variables.sass'
.change-title
  border-bottom: 2px solid white
  margin: 0.5rem auto 1rem auto

.graph-button-bar
  border-bottom: 1px solid white
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)
  padding-bottom: 1rem
  margin-bottom: 1rem !important
  width: 100%
  & > *
    flex: 0 0 auto

.graph
  width: 100%
  #line-chart
    width: 100% !important
    height: 25% !important
.player-status-stats
  // max-width: 500px
  // margin: auto
  .spacer
    flex-grow: 2 !important

  .round-div
    width: 50px
    height: 50px
    border: 2px solid
    border-radius: 50px
    margin: auto
</style>
